import { CircularProgress, createStyles, makeStyles } from '@material-ui/core';
import { NFTS } from '@mogul/shared';
import React, { useContext, useEffect } from 'react';

import { ConnectWalletModal } from '../../../components/common/modal';
import { NFTBalancesComponent } from '../../../components/nft/NFTBalances.component';
import { ModalStateContext } from '../../../contexts/app-state-context/modal-state.context';
import { useWeb3State } from '../../../hooks';
import { useNFTContract } from '../../../hooks/nft-contract.hooks';
import { NFT_CONTRACT_ADDRESS } from '../../../lib/smart-contract-utils';
import styles from './NFTPage.module.css';

interface Props {}

const nftData = {
  nfts: NFTS.ORDERED,
  nftIds: NFTS.ORDERED.map((_, i) => i),
};

const useStyles = makeStyles(() =>
  createStyles({
    loader: {
      color: 'white',
    },
  }),
);

export const NFTPage: React.FC<Props> = () => {
  const classes = useStyles();
  const { walletDetails } = useWeb3State();
  const { setModal } = useContext(ModalStateContext);
  const { nftBalances } = useNFTContract();

  useEffect(() => {
    const timeout = setTimeout(() => setModal(ConnectWalletModal()), 1_000);

    return () => clearTimeout(timeout);
  }, []);

  if (!nftBalances) {
    return (
      <div
        className={styles.nftPageContainer}
        style={{
          display: 'grid',
          placeItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <CircularProgress className={classes.loader} size={100} />
      </div>
    );
  }

  return (
    <div className={styles.nftPageContainer}>
      <NFTBalancesComponent
        contractAddress={NFT_CONTRACT_ADDRESS[walletDetails.chain.type]}
        nfts={nftData.nfts}
        nftIds={nftData.nftIds}
        nftBalances={nftBalances}
      />
    </div>
  );
};
